import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';








export class ChapterEighty extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="Governments in Southeast Asia are known for their strong involvement in the tech startup ecosystem. They want to give a leg-up to their fledgling entrepreneurs and newbie startups that need financial assistance to prove an idea, develop a prototype or test a new service. Help can come in the form of grants, financial incentives and initiatives to support startups in various activities including innovation and R&D, intellectual property protection, marketing and startup incubation." />
        <TextHolder text="Kuo-Yi Lim of Monk’s Hill Ventures said governments are best positioned “to identify areas where risk capital is lacking.” However, an initial, sustained shot is needed to kickstart the VC industry, and that best comes from the government. “This includes policies and programs in areas such as intellectual property protection, entrepreneurial education, and professional services expertise focused on tech such as legal and accounting, all of which are critical in the building of a robust, complete ecosystem.”" />
        <TextHolder text="Agreeing, Bikesh Lakhmichand of 1337 Ventures also pointed out that governments should “take risks on the earlier stages and facilitate policies to drive private sector funds/involvement into ecosystem.”" />


                <div className="block-outer block-outer-textholder">
                  <div className="block-inner block-inner-textholder">
                    <div className="text-title-holder">
                      <p>{ this.props.textTitle }</p>
                    </div>
                    <div className="text-holder">
                      <p>SEA governments also participate in equity investment through their state sovereign wealth funds or government investment funds. Often these venture deals are larger investments in later stage companies. For example, Singapore’s state-owned investment firm, Temasek Holdings, manages a portfolio
                      <a href="https://www.businesstimes.com.sg/government-economy/temasek-may-slow-investments-as-near-term-risks-emerge"> worth more than $300 billion</a>
                      , of which a large portion is invested in digital companies such as Alibaba and Ping An Insurance.</p>

                    </div>
                  </div>
                </div>


        <TextHolder text="To promote business development and a level playing field, policymakers must also introduce new guidelines for business. New rules generally protect consumers and prevent fraud. They could be implemented as regulatory sandboxes where startups can test their revolutionary new ideas in a safe digital environment walled off from the public." />
        <TextHolder text="Some of our interview respondents felt that their countries’ regulations were holding the startup ecosystem back. 'I would like to see a major change on government regulations on foreign ownership, starting and shutting down companies, and financial support for tech startups, among other things. Currently it's very hard, and it's discouraging foreign investment and technopreneurship in general,' said Artie Lopez, co-founder of Brainsparks, who is based in the Philippines. He also noted that several departments of the Filipino government were already working on reforms, and he was hopeful that change would come by the end of 2018." />
        <TextHolder text="Barbara Ximenez, CEO of Shutta, was concerned about internet security legislation that may pass in Vietnam in 2019. “If this were to happen, it would significantly complicate Vietnam’s bid to become a tech startup nation,” she said. While interviewees’ individual viewpoints varied, it’s clear that changing laws and regulations remain top of mind for many startups across SEA." />


        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />
        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/80.js